import { createContext, useContext } from "react";
import type { IntercomProps } from "react-use-intercom";
import type { SupportStatus } from "../services/intercomSession";

export interface SupportChat {
  status: SupportStatus;
  isOpen: boolean;
  show: () => void;
  hide: () => void;
  update: (props: IntercomProps) => void;
}

export const SupportChatContext = createContext<SupportChat>({
  status: "unavailable", isOpen: false,
  show: () => undefined, hide: () => undefined, update: () => undefined,
});

export const useSupportChat = (): SupportChat => useContext(SupportChatContext);
